<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'LEAD_INTEGRATIONS.FACEBOOK.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'INTEGRATIONS.TITLE' | translate"
        [previousPageUrl]="'/app-integrations'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <div class="spaced-out-bar">
      <h2 class="grower">
        {{ 'LEAD_INTEGRATIONS.FACEBOOK.TITLE' | translate }}:
        <a [href]="connectedPageURL$ | async" target="_blank" rel="noopener noreferrer" class="page-link">
          <strong>{{ connectedPageDisplayName$ | async }}</strong>
          <mat-icon class="mat-icon">open_in_new</mat-icon>
        </a>
      </h2>
      <button class="buttons" mat-stroked-button color="primary" (click)="showConfirmDisconnectDialogBox()">
        {{ 'LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_PAGE' | translate }}
      </button>
      <button class="buttons" mat-raised-button color="primary" routerLink="/facebook-ad-leads/settings">
        {{ 'COMMON.SETTINGS' | translate }}
      </button>
    </div>

    <ng-container *ngIf="tokenIsInvalid$ | async">
      <glxy-alert
        type="error"
        class="invalid-token-alert"
        [showAction]="true"
        [actionTitle]="'LEAD_INTEGRATIONS.FACEBOOK.RECONNECT' | translate"
        (actionClick)="sendUserToFacebookToConnect()"
        [showClose]="false"
        [extendedBorder]="true"
      >
        <strong>
          {{ 'LEAD_INTEGRATIONS.FACEBOOK.TOKEN_IS_INVALID_WARNING' | translate }}
        </strong>
      </glxy-alert>
    </ng-container>

    <app-facebook-forms-table [facebookPageID$]="pageID$"></app-facebook-forms-table>
  </glxy-page-wrapper>
</glxy-page>
